function getMode() {
  if(window?.location) {
    const path = window.location.pathname
    const share = /^\/share\//.test(path)
    const preview = /^\/preview\//.test(path)
    return {
      normal: !share && !preview,
      share,
      preview
    }
  }

  return {
    normal: true,
    shared: false,
    preview: false
  }
}

const appMode = getMode()

export default appMode
